import React from 'react';
import { Link } from 'react-router-dom'; 
import logo from './../assets/images/logo.png';

function Navbar() {
  return (
      <header className="main-header" id="header">
        <div className="container">
          <nav className="navbar navbar-expand-lg traperant" id="navbar">
            <Link className="navbar-brand" to="/"><img src={logo} alt="Mono" loading="lazy" /></Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item active">
                  <Link className="nav-link" to="/about">About <span className="sr-only">(current)</span></Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/help">Help</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/disclaimer">Disclaimer</Link>
                </li>
                {/* <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dropdown
                  </a>
                  <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a className="dropdown-item" href="#">Action</a>
                    <a className="dropdown-item" href="#">Another action</a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="#">Something else here</a>
                  </div>
                </li> */}
              </ul>
              <div className="form-inline my-2 my-lg-0">
                <Link className="my-2 my-sm-0 btn btn-primary btn-pill signup" to="/signup">Sign Up</Link>
              </div>
            </div>
          </nav>
        </div>
      </header>
  );
}
export default Navbar;
